import React, {useState} from "react";
import LiverKidney from "../../../assets/images/organs/72x72/Liver-Kidney.png";
import LiverKidneyHover from "../../../assets/images/organs/72x72/Liver-Kidney-Over.png";

function LiverKidneyIcon(props) {
    const [isHover, setIsHover] = useState(false);

    if (props.showHover) {
        return (
            <div 
                className={props.count ? "icon-container organ-count-wrapper" : "icon-container"}
                onMouseEnter={()=> setIsHover(true)}
                onMouseLeave={()=> setIsHover(false)}
            >
                <img src={isHover ? LiverKidneyHover : LiverKidney} alt="Liver Kidney Icon" className="organ-icon large" />
                {props.count &&
                    <div className="organ-count liver-kidney">
                        {props.count}
                    </div>
                }
                
            </div>
        );
    }
    else {
        return (<img src={LiverKidney} alt="Liver Kidney Icon" className="organ-icon large" />);
    }
}

export default LiverKidneyIcon;
